import { GcpBox, GcpTypography } from '@back-office/ui';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Divider from '@material-ui/core/Divider';
import Link from '@material-ui/core/Link';
import makeStyles from '@material-ui/core/styles/makeStyles';
import NavigateNext from '@material-ui/icons/NavigateNext';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(
  () => ({
    link: {
      cursor: 'pointer',
      fontSize: '18px',
    },
  }),
  { name: 'TransactionBreadcrumbs' }
);

interface BillerEnrollmentBreadcrumbsProps {
  handleOnClickBreadcrumbs: () => void;
}

const BillerEnrollmentBreadcrumbs: FC<BillerEnrollmentBreadcrumbsProps> = ({
  handleOnClickBreadcrumbs,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Breadcrumbs
        aria-label="breadcrumb"
        separator={<NavigateNext fontSize="small" />}
      >
        <GcpTypography paint="hitGray">
          <Link
            className={classes.link}
            color="inherit"
            onClick={handleOnClickBreadcrumbs}
          >
            {t('recurring_payment_detail.title')}
          </Link>
        </GcpTypography>
        <GcpTypography paint="black">
          <Link className={classes.link} color="inherit">
            {t('recurring_payment_detail.detail')}
          </Link>
        </GcpTypography>
      </Breadcrumbs>
      <GcpBox mb={3} mt={3}>
        <Divider />
      </GcpBox>
    </>
  );
};

export default BillerEnrollmentBreadcrumbs;
